import defaultPosition from "@/helpers/wc/positionSettings";

export const visitorsListSettings = {
  title: 'Visitors List',
  name: 'visitorsListBase',
  styles: defaultPosition,

  properties: {
    deleteSymbol: '',
    css: {
      list: {
        backgroundColor: 'grey',
        borderColor: 'grey',
        borderWidth: '0px',
        borderRadius: '0px',
      },
      item: {
        color: '#fff',
        borderColor: 'grey',
        borderWidth: '0px',
        padding: '16px',
        fontSize: '16px',
        fontFamily: 'sans-serif',
        textAlign: 'left',
      },
    }
  },
  cssLegend: {
    list: {
      backgroundColor: {
        type: "color",
        name: "Background Color"
      },
      borderColor: {
        type: "color",
        name: "Border"
      },
      borderWidth: {
        type: "int",
        name: "Border Width",
        handler: val => val + 'px'
      },
      borderRadius: {
        type: "int",
        name: "Border Radius",
        handler: val => val + 'px'
      },
    },
    item: {
      color: {
        type: "color",
        name: "Color"
      },
      borderColor: {
        type: "color",
        name: "Border"
      },
      borderWidth: {
        type: "int",
        name: "Border Width",
        handler: val => val + 'px'
      },
      padding: {
        type: "int",
        name: "Padding left/right",
        handler: val => val + 'px'
      },
      fontSize: {
        type: "int",
        name: "Font Size",
        handler: val => val + 'px'
      },
      fontFamily: {
        type: "fontFamily",
        name: "Font Family"
      },
      textAlign: {
        type: "align",
        name: "Align"
      },
    }
  }
};
